import {Component, Input} from '@angular/core';
import {FormBuilder} from '@angular/forms';

@Component({
   selector: 'app-package-detail',
   templateUrl: './package-detail.component.html',
   styleUrls: ['./package-detail.component.css']
})
export class PackageDetailComponent {
   @Input() packageBody: any;
   searchForm;
   packageListItem: any[] = [];

   displayedColumns = ['no', 'package_name', 'amount', 'unit', 'price', 'discount', 'price_discount', 'menu'];
   dataSource: any;

   getPackageList: any[] = [];
   selectedRowIndex = 0;
   priceSumExclude: number = 0;
   priceSumVat: number = 0;
   priceSumInclude: number = 0;

   constructor(private formBuilder: FormBuilder) {
      this.packageBody = {
         'name': '',
         'status': 'enable',
         'billing': 'monthly'
      }

      this.searchForm = this.formBuilder.group({
         search: '',
      });

      this.packageListItem = [
         {
            packageName: 'User', amount: '100', unit: 'user', price: 7000, discount: 2000, priceDiscount: 0, selected: false
         },
         {
            packageName: 'Additional User Storage', amount: 0, unit: 'GB', price: 0, discount: 0, priceDiscount: 0, selected: false
         },
         {
            packageName: 'Site', amount: 0, unit: 'GB', price: 0, discount: 0, priceDiscount: 0, selected: false
         },
         {
            packageName: 'Site Storage', amount: 0, unit: 'GB', price: 0, discount: 0, priceDiscount: 0, selected: false
         },
         {
            packageName: 'Corp CA', amount: 0, unit: 'GB', price: 0, discount: 0, priceDiscount: 0, selected: false
         },
         {
            packageName: 'Individual CA', amount: 0, unit: 'GB', price: 0, discount: 0, priceDiscount: 0, selected: false
         },
         {
            packageName: 'แพ็คเรื่มต้น', amount: 0, unit: 'GB', price: 0, discount: 0, priceDiscount: 0, selected: false
         },
         {
            packageName: 'รายการส่งเสริมการขาย A', amount: 0, unit: 'GB', price: 0, discount: 0, priceDiscount: 0, selected: false
         },
         {
            packageName: 'รายการกำหนดเอง', amount: 0, unit: 'GB', price: 0, discount: 0, priceDiscount: 0, selected: false
         },
      ];
      this.dataSource = this.getPackageList;
   }

   onSelect(packageItem: any) {
      if (!packageItem.selected) {
         packageItem.selected = !packageItem.selected;
         packageItem.id = Date.now();
         this.dataSource = [...this.dataSource, packageItem];
      }
      this.getSummary();
   }

   deletePackage(packageItem: any) {
      this.dataSource = this.dataSource.filter((item) => item.id !== packageItem.id);
      this.packageListItem.forEach((item) => {
         if(item.packageName === packageItem.packageName) {
            item.selected = false;
         }
      });
      this.getSummary();
   }

   getDiscountPrice(element: any) {
      element.priceDiscount = element.price - element.discount;
      return element.priceDiscount;
   }

   getSummary() {
      setTimeout(() => {
         this.priceSumExclude = 0;
         this.priceSumVat = 0;
         this.priceSumInclude = 0;
         this.dataSource.forEach((item) => {
            this.priceSumExclude += item.priceDiscount;
         });
         if (this.priceSumExclude > 0) {
            this.priceSumVat = (this.priceSumExclude * 7 / 100);
         }
         if (this.priceSumExclude > 0) {
            this.priceSumInclude = (this.priceSumExclude - this.priceSumVat);
         }
      },0);

   }
}
